﻿import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import type { IUploadStore } from "../../UploadStore";
import { injectFromAppUpload } from "../../inject";
import { PatientToUploadComponent } from "./patient/PatientToUploadComponent";
import { StaticNotificationComponent } from "../../../shared-components/static-notification/StaticNotificationComponent";
import { ArrangeSupportedNonDicomFilesComponent } from "./non-dicom-files/ArrangeSupportedNonDicomFilesComponent";

interface IPatientsUploadComponent {
    resourcesStore?: IResourcesStore;
    uploadStore?: IUploadStore;
}

@injectFromAppUpload<IPatientsUploadComponent>(stores => ({
    uploadStore: stores.uploadStore,
    resourcesStore: stores.resourcesStore,
}))
@observer
export class PatientsUploadComponent extends React.Component<IPatientsUploadComponent> {
    render() {
        const { resourcesStore, uploadStore } = this.props;
        const { resources } = resourcesStore!;
        const { patientsFound, supportedNonDICOMFilesToArrange } = uploadStore!;

        return (
            <div id={"patients-upload-component"} className={patientsFound.length > 0 || supportedNonDICOMFilesToArrange.length > 0 ? "active" : "inactive"}>
                <h2>
                    <span>2</span> {resources.VerifyPatientAndStudyInformationAndUploadImagesFiles}
                </h2>

                {patientsFound.length > 1 && (
                    <StaticNotificationComponent type={"warning"} title={resources.FoundXDifferentPatients.replace("{0}", patientsFound.length.toString())}>
                        {resources.PleaseVerifyPatientInformation}
                    </StaticNotificationComponent>
                )}

                <ArrangeSupportedNonDicomFilesComponent />

                {patientsFound.length > 0 && (
                    <div id={"patients-upload-container"}>
                        {patientsFound.map(p => (
                            <PatientToUploadComponent key={p.patientGuid} patientToUpload={p} />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}
